import { useRouteData } from '../RouteDataContext';

/**
 * Profile
 * Displays the user's profile information including name, phone, and address.
 */
export const Profile = () => {
    const { userData } = useRouteData();
    return (
        <div className="container" style={{ backgroundColor: 'white', minHeight: '100vh' }}>

            <div className='card mt-4 bg-gray-100 border-shadow'>
                <div className='card-body p-3'>
                    <div className='pb-2 fs-3 text-capitalize fw-semibold '>
                        {userData?.user?.first_name} {userData?.user?.last_name}
                    </div>
                    <div className="d-flex gap-2 flex-column">
                        <div className="blue"><i className="bi text-danger fw-semibold bi-phone-fill  me-2"> </i>  {userData?.user?.phone}</div>
                        <div className="blue"> <i className="bi text-danger fw-semibold bi-whatsapp me-2"> </i> {userData?.user?.phone}</div>
                        {/* <div className="span_first d-flex"> <i className="bi text-danger fw-semibold bi-envelope-fill me-2"></i>
                            {userData?.user?.email}
                        </div> */}
                        <div className="span_first d-flex"> <i className="bi me-2 fs-4 text-danger fw-semibold bi-geo-alt-fill"></i>
                            {userData?.user?.address?.address}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
